import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DRAWER_DATA, DRAWER_REF, DrawerRef } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { CIPXDrawerContentInterface } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-content.interface';
import { RiderRequestComponent } from '@sbd-account-portal/app/modules/rider-request/rider-request.component';
import {
  Address,
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { BondsListItem } from '@sbd-account-portal/app/modules/bonds/bonds-list/bonds-list.type';
import { QuoteRequestsListItem } from '@sbd-account-portal/app/modules/quote/requests-list/quote-request.type';

export interface RiderRequestDrawerData {
  title?: string;
  qr: OpenQuoteRequestsItem | BondsListItem | QuoteRequestsListItem;
}


@Component({
  selector: 'sbd-account-portal-frontend-rider-request-wrapper',
  imports: [CommonModule, RiderRequestComponent],
  templateUrl: './rider-request-wrapper.component.html',
  styleUrl: './rider-request-wrapper.component.scss',
})
export class RiderRequestWrapperComponent implements CIPXDrawerContentInterface<RiderRequestDrawerData>, OnInit, OnDestroy {
  @Output() closeRequested: EventEmitter<void>;

  data = inject(DRAWER_DATA, { optional: true }) as RiderRequestDrawerData | null;

  drawerRef = inject(DRAWER_REF, { optional: true }) as DrawerRef<RiderRequestWrapperComponent> | null;

  concernedQuoteRequest: OpenQuoteRequestsItem | BondsListItem | QuoteRequestsListItem = this.data?.qr;

  ngOnInit(): void {
    this.drawerRef?.setTitle(this.data?.title ?? 'Rider Request');
  }

  ngOnDestroy(): void {
    this.drawerRef?.close();
  }

  closeDrawer($event: any): void {
    this.drawerRef?.close();
  }

  requestSubmittedEvent($event: any): void {
    this.drawerRef?.close();
  }

}
